export const filters_store = {
    protocol_id: {
        type:'list',
        list: [],
        value: null,
        placeholder: '',
        item_text:"name",
        item_value:"id",
        // style: 'max-width:200px'
    },
    cin: {
        type:'text',
        replace: "%VALUE%",
        value: null
    },
    ae_verbatim_reported: {
        type:'text',
        replace: "%VALUE%",
        value: null
    },
    patient_id: {
        type:'text',
        replace: "%VALUE%",
        placeholder: '',
        style: 'max-width:60px',
        value: null
    },
    'site.code': {
        type:'text',
        replace: "%VALUE%",
        placeholder: '',
        style: 'max-width:60px',
        value: null
    },
    receipt_date: {
        type:'daterange',
        placeholder: 'Range',
        value: {start:'', end:''},
        style: 'max-width:120px',
        // style: 'max-width:60px'
    },
    case_assessment: {
        type:'list',
        list: ['ae', 'sae', 'sar', 'susar', 'aesi'],
        value: undefined,
        placeholder: '',
        style: 'max-width:60px',
        value: null
    },
    crf: {
        type:'list',
        value: undefined,
        list: [{name:"Yes", value:1}, {name:"No",value:0}],
        placeholder: '',
        item_text:"name",
        item_value:"value",
        style: 'max-width:60px',
        value: null
    },
    status: {
        type:'list',
        value: undefined,
        list: ["Open", "Close", "Warning", "Query", "Canceled"],
        placeholder: '',
        style: 'max-width:90px',
        value: null
    },
    'protocol.sponsor_id': {
        value: undefined
    },
    'protocol.status': {
        type:'list',
        value: undefined,
    }
}